module.exports = __webpack_public_path__ + "img/school-expenses.88f38fd8.png";